var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableSelectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87506 8.62476L8.87506 9.37476M8.12506 8.62476L8.12506 9.37476M8.87506 1.62476L8.87506 2.37476M8.12506 1.62476L8.12506 2.37476M8.87506 15.6248L8.87506 16.3748M8.12506 15.6248L8.12506 16.3748M8.5 10C7.94771 10 7.5 9.55228 7.5 9C7.5 8.44772 7.94771 8 8.5 8C9.05228 8 9.5 8.44772 9.5 9C9.5 9.55228 9.05228 10 8.5 10ZM8.5 3C7.94772 3 7.5 2.55229 7.5 2C7.5 1.44772 7.94772 1 8.5 1C9.05228 1 9.5 1.44772 9.5 2C9.5 2.55229 9.05228 3 8.5 3ZM8.5 17C7.94771 17 7.5 16.5523 7.5 16C7.5 15.4477 7.94771 15 8.5 15C9.05228 15 9.5 15.4477 9.5 16C9.5 16.5523 9.05228 17 8.5 17Z",
    stroke: "#D0D5DD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87506 8.62476L2.87506 9.37476M2.12506 8.62476L2.12506 9.37476M2.87506 1.62476L2.87506 2.37476M2.12506 1.62476L2.12506 2.37476M2.87506 15.6248L2.87506 16.3748M2.12506 15.6248L2.12506 16.3748M2.5 10C1.94771 10 1.5 9.55228 1.5 9C1.5 8.44772 1.94771 8 2.5 8C3.05228 8 3.5 8.44772 3.5 9C3.5 9.55228 3.05228 10 2.5 10ZM2.5 3C1.94772 3 1.5 2.55229 1.5 2C1.5 1.44772 1.94772 1 2.5 1C3.05228 1 3.5 1.44772 3.5 2C3.5 2.55229 3.05228 3 2.5 3ZM2.5 17C1.94771 17 1.5 16.5523 1.5 16C1.5 15.4477 1.94771 15 2.5 15C3.05228 15 3.5 15.4477 3.5 16C3.5 16.5523 3.05228 17 2.5 17Z",
    stroke: "#D0D5DD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSelectIcon);
export default __webpack_public_path__ + "static/media/tableSelectIcon.fc7392b5de5ae6cfe70db763aef3ca2a.svg";
export { ForwardRef as ReactComponent };